import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useImpersonate from 'services/auth/useImpersonate';
import { getIsAuthenticated } from 'store/user';
import { seenIndicatorDB } from 'utils/seenIndicatorDB';

export default function useHydrateSeenIndicators() {
  const isAuthenticated = useSelector(getIsAuthenticated);
  const { impersonateId } = useImpersonate();

  useEffect(() => {
    if (!isAuthenticated) return;
    void seenIndicatorDB.fetchAndSetPersisted();
  }, [isAuthenticated, impersonateId]);
}
